module.exports = __webpack_public_path__ + "img/antes_despues_96.3a655435.png";